import { useMemo } from "react";
import { useAtomValue } from "jotai";
import { Center, Text3D } from "@react-three/drei";
import { deviceAtom, languageAtom } from "../../GlobalState.jsx";
import HowToPlay from "../HowToPlay.jsx";
import MeshColors from "../MeshColors.jsx";
import translations from "../../dictionaries/translations.js";

export default function SecondSection({ position }) {
  const device = useAtomValue(deviceAtom)
  const language = useAtomValue(languageAtom)

  const howToPlay = useMemo(() => {
    return <HowToPlay 
      device={device} 
      position={[-1,0,-1]} 
      scale={0.6}
      closeButton={false}
    />
  }, [device])
  return <group name='rulebook' position={position}>
    {/* <mesh name='background-panel' position={[0.7, -0.5, 0]}>
      <boxGeometry args={[8.4, 0.01, 14]}/>
      <meshStandardMaterial color='black' transparent opacity={0.5}/>
    </mesh> */}
    <group name='rulebook-label' position={[0.67, 0, -5.6]} scale={0.9}>
      <mesh name='background-outer' scale={[3.0, 0.01, 0.75]} position={[0,0,0]}>
        <boxGeometry args={[1, 1, 1]}/>
        <meshStandardMaterial color='orange'/>
      </mesh> 
      <mesh name='background-inner' scale={[2.95, 0.02, 0.7]} position={[0,0,0]}>
        <boxGeometry args={[1, 1, 1]}/>
        <meshStandardMaterial color={MeshColors.spaceDark}/>
      </mesh>
      <Center key={Math.random()} position={[0, 0.02, 0]} rotation={[-Math.PI/2, 0, 0]}>
        <Text3D
          font={language === 'korean' ? "/fonts/Maplestory_Bold.json" : language === 'chinese' ? "/fonts/Xiao Xiangjiao font_Regular.json" : "/fonts/Luckiest Guy_Regular.json"}
          size={0.4}
          height={0.01}
        >
          {translations.lobby.rulebook[language]}
          <meshStandardMaterial color='orange'/>
        </Text3D>
      </Center>
    </group>
    {howToPlay}
  </group>
}
